import RegistrationManager from "../features/registration-manager/RegistrationManager";

export default function Registration() {
  const entrypointUrl = window.location.toString();
  return <RegistrationManager entrypointUrl={entrypointUrl} />;
}
